import { Button, Popover } from 'antd';
import { observer } from 'mobx-react-lite';
import { type ComponentProps } from 'react';

import { UserIcon } from '../../../../base-ui/icons/UserIcon';
import { ContentContainer } from '../../../../pages/quality/care-team/measure-pages/shared-components/styles';
import { MainLayoutUserPreferences, type MainLayoutUserPreferencesProps } from './MainLayoutUserPreferences';

export interface MainLayoutUserPreferencesButtonProps
	extends
		MainLayoutUserPreferencesProps,
		Omit<ComponentProps<typeof Button>, 'onClick' | 'type' | 'shape' | 'icon' | 'children'> {}

export const MainLayoutUserPreferencesButton = observer(function MainLayoutUserPreferencesButton({
	userName,
	showSignOut,
	onSignOut,
	settings,
	...buttonProps
}: MainLayoutUserPreferencesButtonProps) {
	return (
		<ContentContainer>
			<Popover
				{...{
					placement: 'bottomRight',
					trigger: ['hover', 'click'],
					content: <MainLayoutUserPreferences {...{ userName, showSignOut, onSignOut, settings }} />,
					children: <Button {...{ type: 'primary', shape: 'circle', icon: <UserIcon />, ...buttonProps }} />,
				}}
			/>
		</ContentContainer>
	);
});
